import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
  VueAxios
} from './axios'
import message from 'ant-design-vue/es/message'
import notification from 'ant-design-vue/es/notification'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'
import config from '@/config'

import errorHandler from '@/errorHandler'

export class ApiError extends Error {
  constructor(code, status, message) {
    super(message)
    this.code = code
    this.status = status
    this.message = message
  }
}

// 创建 axios 实例
const service = axios.create({
  baseURL: config.api.baseURL, // api base_url
  // baseURL: "/api",
  timeout: 6000 // 请求超时时间
})

service.interceptors.request.use(config => {
  const {
    token
  } = store.state.auth
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(null, async error => {
  if (error.message.indexOf('Network Error') >= 0) {
    error = new ApiError('0000', 0, '网络错误，无法连接到服务器')
  } else if (error.response.data) {
    const {
      code,
      status,
      message
    } = error.response.data
    error = new ApiError(code, status, message)
  }
  errorHandler(error)
  return Promise.reject(error)
})


const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
    Vue.prototype.$isApiError = error => {
      return error instanceof ApiError
    }
  }
}

export {
  installer as VueAxios,
  service as axios
}